declare const $: any;
declare const document: any;

const EVENT_NAMESPACE = '.qaDragulaScroll';
let container: any = null;
let win: any = null;
let latestClientY: number | null = null;
let rafId: number | null = null;
let isActive = false;

const applyScroll = () => {
  rafId = null;

  if (!isActive || latestClientY === null || !container || !win) {
    return;
  }

  const height = win.height();
  const distance = (latestClientY - height / 2) * 0.1;
  container.scrollTop(distance + container.scrollTop());
};

const onMouseMove = (e) => {
  latestClientY = e.clientY;

  if (rafId !== null) {
    return;
  }

  rafId = requestAnimationFrame(applyScroll);
};

export const dragulaScroll = function() {
  if (isActive) {
    return;
  }

  isActive = true;

  // use document and window as container
  container = $(document);
  win = $(window);

  /**
   * When the editor is maximized, we have to use the editor element instead of the document element,
   * as it is set to overlay the document. Thus scrolling the document would not really make any sense ;p
   */
  if ($('.qa-editor.maximized').length) {
    container = $('.qa-editor.maximized');
    win = $('.qa-editor.maximized');
  }

  /**
   * Registers a handler for the "mouse move" event. Scrolls the editor by the mouse position
   */
  $(document).on(`mousemove${EVENT_NAMESPACE}`, onMouseMove);
};

export const dragulaScrollStop = function() {
  isActive = false;
  latestClientY = null;
  $(document).off(`mousemove${EVENT_NAMESPACE}`, onMouseMove);

  if (rafId !== null) {
    cancelAnimationFrame(rafId);
    rafId = null;
  }
};
